import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "icon", "spinner", "cell"]

  fetch() {
    // Disable button and show spinner
    this.buttonTarget.disabled = true
    this.iconTarget.style.display = 'none'
    this.spinnerTarget.style.display = 'inline-block'

    // Show spinners in all cells
    this.cellTargets.forEach(cell => {
      cell.innerHTML = '<span class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>'
    })

    // Collect slug/version data from cells
    const documents = this.cellTargets.map(cell => {
      const entry = { slug: cell.dataset.slug }
      if (cell.dataset.version) {
        entry.version = cell.dataset.version
      }
      return entry
    })

    // Build form data for Rails
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.element.dataset.batchUnlockUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({ documents: documents })
    })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      return response.text()
    })
    .then(html => {
      // Let Turbo process the stream response
      Turbo.renderStreamMessage(html)
      // Re-enable button
      this.buttonTarget.disabled = false
      this.iconTarget.style.display = 'inline-block'
      this.spinnerTarget.style.display = 'none'
    })
    .catch(error => {
      console.error('Batch unlock check failed:', error)
      // Revert cells to dash
      this.cellTargets.forEach(cell => {
        cell.innerHTML = '<span class="text-muted"> – </span>'
      })
      // Re-enable button
      this.buttonTarget.disabled = false
      this.iconTarget.style.display = 'inline-block'
      this.spinnerTarget.style.display = 'none'
    })
  }
}
